import styled from "styled-components";

const CartBadge = styled.span`
background-color: #337a63;
color:white;
padding: 0.25rem 1rem;
border-radius: 25px;
margin-left: 1rem;
font-weight: bold;
`

export default CartBadge